import { render, staticRenderFns } from "./gerenFuncionario.vue?vue&type=template&id=a1a6c1e2&scoped=true"
import script from "./gerenFuncionario.vue?vue&type=script&lang=js"
export * from "./gerenFuncionario.vue?vue&type=script&lang=js"
import style0 from "./gerenFuncionario.vue?vue&type=style&index=0&id=a1a6c1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a6c1e2",
  null
  
)

export default component.exports